<template>
	<view>
		<scroll-view scroll-y>
			<view class="vve">
				
			</view>
			<view class="content">
				<navigator hover-class="none" :url="'/pages/basics/' + item.name" class="nav-li" navigateTo :class="'bg-'+item.color"
				 :style="[{animation: 'show ' + ((index+1)*0.2+1) + 's 1'}]" v-for="(item,index) in elements" :key="index">
				<view class="nav-title">{{item.title}}</view>
				<view class="nav-name">{{item.name}}</view>
				<text :class="'cuIcon-' + item.cuIcon"></text>
				</navigator>
			</view>
		</scroll-view>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				elements:[{
					title: '组托',
					name: 'comb',
					color: 'yellow',
					cuIcon: 'goodsnew'
				},
				{
					title: '入库单组托',
					name: 'combPro',
					color: 'olive',
					cuIcon: 'goods'
				},
				{
					title: '库存盘点',
					name: 'stockCheck',
					color: 'cyan',
					cuIcon: 'squarecheck'
				},
				{
					title: '库存查询',
					name: 'stockQuery',
					color: 'blue',
					cuIcon: 'searchlist'
				}]
			}
		},
		onLoad() {

		},
		methods: {

		}
	}
</script>

<style>
	.content {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}
	.vve {
		margin-top: 300rpx;
	}

	
	
</style>
